// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__4stIK","content":"styles_content__YZDSf","checkbox":"styles_checkbox__2zbr1","checkboxLabel":"styles_checkboxLabel__2nPpZ"};